import request from "../utils/request"

export function fetchNotices(params = {}) {
  return request({
    url: "/admin/notices",
    method: "get",
    params
  })
}

export function fetchNoticeDetail(id) {
  return request({
    url: `/admin/notices/${id}`,
    method: "get"
  })
}

export function saveNotice(data) {
  return request({
    url: "/admin/notices",
    method: "post",
    data
  })
}

export function deleteNotice(id) {
  return request({
    url: `/admin/notices/${id}`,
    method: "delete"
  })
}
